import React from 'react';
import { Drawer, Form, Select, message } from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
import debounce from 'lodash/debounce';
import { getCountryCallingCode } from 'libphonenumber-js/min';
import { removeCommaFromEnd } from '../../Utils/TextUtils';
import { getAddCandidateDrawerVisibleStatus } from '../../Reducers/AddCandidateReducer';
import { getJobUtilities } from '../../Reducers/JobReducer';
import * as AddCandidateActions from '../../Actions/AddCandidateActions';
import * as LocationSearchActions from '../../Actions/LocationSearchActions';
import * as CandidateActions from '../../Actions/CandidateActions';
import * as JobActions from '../../Actions/JobActions';
import styles from './AddCandidateContainer.module.scss';
import AddCandidateForm from './AddCandidateForm';

const mapStateToProps = state => ({
  visible: getAddCandidateDrawerVisibleStatus(state),
  utilities: getJobUtilities(state),
});

const mapDispatchToProps = {
  toggleAddCandidateDrawerVisibleStatus: AddCandidateActions.toggleAddCandidateDrawerVisibleStatus,
  fetchLocations: LocationSearchActions._fetchLocations,
  fetchJobs: JobActions._fetchJobs,
  createCandidate: CandidateActions.createCandidate,
  changeCandidateStatus: CandidateActions.changeCandidateStatus,
};

const { Option } = Select;

const AddCandidateContainer = props => {
  const {
    visible,
    toggleAddCandidateDrawerVisibleStatus,
    form,
    utilities,
    fetchJobs,
    version,
    fetchLocations,
    createCandidate,
    changeCandidateStatus,
    location,
  } = props;
  const [sourceDropdown, setSourceDropdown] = React.useState('');
  const [fetchJobsApiStatus, setFetchJobsApiStatus] = React.useState();
  const [createCandidateApiStatus, setCreateCandidateApiStatus] = React.useState();
  const [fetchLocationApiStatus, setFetchLocationApiStatus] = React.useState();
  const [fetchedLocations, setFetchedLocations] = React.useState([]);
  const [otherSource, setOtherSource] = React.useState('');
  const [resume, setResume] = React.useState([]);
  const [resumeContent, setResumeContent] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [jobContext, setJobContext] = React.useState('Job');

  const resetFormFields = () => {
    form.resetFields();
    setSourceDropdown('');
    setOtherSource('');
    setResume([]);
    setResumeContent(null);
    setJobContext('Job');
    setFetchJobsApiStatus(undefined);
    setFetchLocationApiStatus(undefined);
    setOptions([]);
    setCreateCandidateApiStatus(undefined);
    setFetchedLocations([]);
  };

  const extractIdFromUrl = () => {
    const pathParts = location.pathname.split('/');
    let urlJobContext = '';
    const jobsIndex = pathParts.indexOf('jobs');
    const segmentsIndex = pathParts.indexOf('segments');

    if (jobsIndex !== -1 && jobsIndex + 1 < pathParts.length) {
      const id = pathParts[jobsIndex + 1];
      urlJobContext = 'Job';
      return !isNaN(id) ? { id: Number(id), urlJobContext } : null;
    }

    if (segmentsIndex !== -1 && segmentsIndex + 1 < pathParts.length) {
      const id = pathParts[segmentsIndex + 1];
      urlJobContext = 'Segment';
      return !isNaN(id) ? { id: Number(id), urlJobContext } : null;
    }

    return null;
  };

  const { id: jobIdFromUrl, urlJobContext } = extractIdFromUrl() ?? {};

  React.useEffect(() => {
    if (jobIdFromUrl && urlJobContext) {
      fetchAndJobId(jobIdFromUrl, urlJobContext);
    } else {
      form.resetFields();
    }
  }, [location.pathname, jobIdFromUrl]);

  const onCloseDrawer = () => {
    resetFormFields();
    toggleAddCandidateDrawerVisibleStatus(false);
  };

  const onChangeJobContext = e => {
    if (jobContext !== e.target.value) {
      setOptions([]);
      form.setFieldsValue({ jobId: undefined });
      setJobContext(e.target.value);
    }
  };

  const fetchJobsOrLists = async (searchTerm, _destinationName) => {
    const payload =
      _destinationName === 'Segment'
        ? {
            count: 10,
            aryaJobStatus: 'Open',
            statusId: 1,
            searchTerm,
            EntityType: 'Segment',
            isAssigned: true,
          }
        : {
            count: 10,
            aryaJobStatus: 'Open',
            statusId: 1,
            searchTerm,
            isAssigned: true,
          };
    const result = await fetchJobs(payload);
    const updatedResult = result?.Jobs ?? [];
    setOptions(
      (updatedResult ?? []).map(job => ({
        value: job.JobId,
        text: `${job.JobTitle} (Id: ${version !== 'ats' || jobContext === 'Segment' ? job.JobId : job.JobCode}) ${
          jobContext === 'Job' ? '|' : ''
        } ${
          jobContext === 'Segment' || job.Location === undefined || job.Location === ''
            ? ''
            : removeCommaFromEnd(job.Location)
        } ${jobContext === 'Segment' || job.Location === undefined || job.Location === '' ? '' : ','} ${
          jobContext === 'Job' ? job.CountryCode : ''
        } `,
      }))
    );
  };
  const fetchAndJobId = async (id, _destinationName) => {
    const payload =
      _destinationName === 'Segment'
        ? {
            count: 10,
            status: 'Open',
            statusId: 1,
            searchTerm: id,
            EntityType: 'Segment',
            isAssigned: true,
          }
        : {
            count: 10,
            status: 'Open',
            statusId: 1,
            searchTerm: id,
            isAssigned: true,
          };
    const result = await fetchJobs(payload);
    if (result?.Jobs?.length > 0) {
      const job = result.Jobs[0];
      const option = {
        value: job.JobId,
        text: `${job.JobTitle} (Id: ${version !== 'ats' || jobContext === 'Segment' ? job.JobId : job.JobCode}) ${
          jobContext === 'Job' ? '|' : ''
        } ${
          jobContext === 'Segment' || job.Location === undefined || job.Location === ''
            ? ''
            : removeCommaFromEnd(job.Location)
        } ${jobContext === 'Segment' || job.Location === undefined || job.Location === '' ? '' : ','} ${
          jobContext === 'Job' ? job.CountryCode : ''
        }`,
      };
      setOptions([option]);
      setJobContext(_destinationName);
      form.setFieldsValue({ jobId: job.JobId });
    }
  };

  const onSearch = debounce(async (value, _destinationName) => {
    if (value.length) {
      setFetchJobsApiStatus('INPROGRESS');
      await fetchJobsOrLists(value, _destinationName);
      setFetchJobsApiStatus('COMPLETED');
    }
  }, 600);

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      handleSubmission(values);
    });
  };

  const handleSubmission = async values => {
    const { email, fullName, location, phone, prefix, sources } = values;
    const country = location.split('-')[location.split('-').length - 1];
    const city = location.split('-')[0];
    const state = location.split('-').length === 3 ? location.split('-')[1] : '';
    const locationString = state ? `${city}, ${state}` : `${city}`;
    const todayDate = new Date(Date.now());
    const fileList = resume[0];
    const payload = {
      Emails: [email],
      Resumes: [
        {
          Content:
            fileList.type === 'text/html' || fileList.type === 'text/plain'
              ? resumeContent
              : resumeContent.split(',')[1],
          Name: fileList.name,
          Length: fileList.size,
          MediaType: fileList.type,
          Date: fileList.lastModifiedDate,
        },
      ],
      Name: fullName,
      Location: locationString,
      Country: country,
      Sources: [
        {
          Portal: 'Internal',
          Type: 'Primary',
        },
        {
          Portal: 'Internal',
          Type: 'Original',
        },
      ],
      ExternalSource: sources === 'Others' ? otherSource : sources,
      ProfileDate: todayDate.toISOString(),
      LatestResumeDate: todayDate.toISOString(),
      LastActivityDate: todayDate.toISOString(),
    };
    if (phone) {
      payload.Phones = [`${prefix.split('-')[0]}${phone}`];
    }
    try {
      setCreateCandidateApiStatus('INPROGRESS');
      const responseData = await createCandidate(payload);
      if (values.jobId) {
        const postData = {
          candidateId: responseData.id,
          status: 'Shortlisted',
          jobId: values.jobId,
          mustHaves: [],
        };
        await changeCandidateStatus(postData, null, true, jobContext.toLowerCase());
      }
      setCreateCandidateApiStatus('COMPLETED');
      onCloseDrawer();
    } catch (error) {
      setCreateCandidateApiStatus('FAILED');
      onCloseDrawer();
    }
  };

  const handleLocationSearch = debounce(async value => {
    if (value.length) {
      setFetchLocationApiStatus('INPROGRESS');
      const _locationSuggestions = await fetchLocations({ filter: { country: 'US', search: value, size: 10 } });
      setFetchedLocations(_locationSuggestions);
      setFetchLocationApiStatus('COMPLETED');
    }
  }, 600);

  const { getFieldDecorator } = form;
  const countries = _.get(utilities, 'countries', false) || [];
  const countriesMenu = countries
    .filter(country => {
      try {
        return getCountryCallingCode(country.Iso2Code);
      } catch {
        return null;
      }
    })
    .sort((c1, c2) => {
      const c1CallingCode = parseInt(getCountryCallingCode(c1.Iso2Code), 10);
      const c2CallingCode = parseInt(getCountryCallingCode(c2.Iso2Code), 10);
      if (c1CallingCode < c2CallingCode) {
        return -1;
      }
      if (c2CallingCode < c1CallingCode) {
        return 1;
      }
      return 0;
    })
    .map(country => {
      const countryCallingCode = getCountryCallingCode(country.Iso2Code);
      return (
        <Option
          key={countryCallingCode}
          value={`${countryCallingCode}-${country.Iso2Code}-${country.Name}`}
        >{`(+${countryCallingCode}) ${country.Name}`}</Option>
      );
    });
  const prefixSelector = getFieldDecorator('prefix', {
    initialValue: '1-US-USA',
  })(
    <Select
      showSearch
      style={{ width: 100 }}
      className={styles.countryDropdown}
      getPopupContainer={node => node.parentNode}
    >
      {countriesMenu}
    </Select>
  );

  const sourceList = ['Monster', 'LinkedIn', 'Indeed', 'Career Builder', 'ZipRecruiter', 'ZoomInfo', 'Resume Library', 'Others'];

  const beforeUpload = file => {
    return new Promise(resolve => {
      const reader = new FileReader();
      if (file.type === 'text/html' || file.name.endsWith('.html') || file.type === 'text/plain') {
        reader.readAsText(file);
        reader.onload = () => {
          const htmlContent = reader.result;
          setResumeContent(htmlContent);
          resolve(false);
        };
      } else {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64 = reader.result;
          setResumeContent(base64);
          resolve(false);
        };
      }
    });
  };

  const removeResume = () => {
    setResume([]);
    setResumeContent(null);
  };

  const handleUpload = ({ file, fileList }) => {
    if (file.status === 'removed') {
      setResume(fileList.filter(item => item.uid !== file.uid));
      setTimeout(() => form.validateFields(['resume'], {}), 0);
    } else {
      const validExtensions = ['.doc', '.docx', '.pdf', '.txt', '.html'];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        message.error('File format is not supported');
        return;
      }
      const updatedFile = {
        ...file,
        status: 'done',
      };
      setResume([updatedFile]);
      setTimeout(() => form.validateFields(['resume'], {}), 0);
    }
  };

  const handleOtherSource = e => {
    setOtherSource(e.target.value);
    form.setFieldsValue({ sources: form.getFieldValue('sources') });
    form.validateFields(['sources']);
  };

  return (
    <div>
      <Drawer
        visible={visible}
        width={580}
        onClose={onCloseDrawer}
        title="Add Candidate"
        className={styles.addCandidateDrawer}
        bodyStyle={{ padding: '4px 0px 0px' }}
      >
        <AddCandidateForm
          form={form}
          onCloseDrawer={onCloseDrawer}
          beforeUpload={beforeUpload}
          resume={resume}
          handleUpload={handleUpload}
          removeResume={removeResume}
          createCandidateApiStatus={createCandidateApiStatus}
          fetchedLocations={fetchedLocations}
          handleLocationSearch={handleLocationSearch}
          fetchLocationApiStatus={fetchLocationApiStatus}
          prefixSelector={prefixSelector}
          otherSource={otherSource}
          setSourceDropdown={setSourceDropdown}
          sourceList={sourceList}
          sourceDropdown={sourceDropdown}
          handleOtherSource={handleOtherSource}
          fetchJobsApiStatus={fetchJobsApiStatus}
          jobContext={jobContext}
          onSearch={onSearch}
          onChangeJobContext={onChangeJobContext}
          jobIdOptions={options}
          handleSubmit={handleSubmit}
        />
      </Drawer>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddCandidateContainer));
